import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
import { Button, Dropdown, Form, InputGroup, Spinner } from 'react-bootstrap';
import * as XLSX from "xlsx";
import Modal from 'react-bootstrap/Modal';
import CheckIcon from '@mui/icons-material/Check';
import { useEffect, useState } from 'react';
import InsufficientPermission from '../../custom/InSufficientPermission';
import { Table, TableBody, Checkbox, ListItemText, TableHead, TableCell, TableContainer, TableRow, Paper, Avatar, TextField, Select, MenuItem } from '@mui/material';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateLoading } from '../../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';
import { downloadFailedBotsExcel } from '../../../utils/downloadFailedBotsExcel';
import ReplyIcon from '@mui/icons-material/Reply'


const defaultImage = 'https://d2up68x544gew2.cloudfront.net/user-profile/3cc28a96-f911-4a36-be9b-e0db34d78119/image1635604576.jpg';

export const GenerateBotAccount = () => {
    const router = useNavigate()
    const [fileData, setFileData] = useState([]);
    const [categoryFilterData, setCategoryFilterData] = useState([]);
    const [selectedCategoryValues, setSelectedCategoryValues] = useState([]);
    const [numberOfBots, setNumberOfBots] = useState(0);
    const [countryDropdownText, setCountryDropdownText] = useState({ id: '', label: 'Select Country' });
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [countryCodeList, setCountryCodeList] = useState([{ id: '', name: 'Select Country' }]);
    const [users, setUsers] = useState([]);
    const [showGenAiModal, setShowGenAiModal] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [failedBots, setFailedBots] = useState([]); // Track failed bots with errors

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userData = useSelector(state => state?.userData);

    // Handle file upload and parse Excel data
    const handleChangeFile = (e) => {
        const file = e?.target?.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(sheet);
            setFileData(data);
        };
    };

    // Download sample Excel file
    const handleDownloadSample = async () => {
        try {
            setIsLoading(true);
            const response = await fetch("https://d2up68x544gew2.cloudfront.net/sample-bot-account-format.xlsx");
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "sample-bot-account-format.xlsx";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading the file:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Fetch category filter data
    const getCategoryFilterData = async () => {
        try {
            dispatch(updateLoading(true));
            const path = `${urls.tagInterestListKeyValuePair}?keyword=`;
            const res = await ApiCaller.get({}, path, userData?.access_token);
            const response = await res.response.json();
            if (response.status === 200 || response.status === '200') {
                const tempArray = response?.data?.map(data => ({
                    label: data?.value,
                    value: data?.key
                }));
                setCategoryFilterData(tempArray);
            } else {
                showDangerToast(response.message);
            }
        } catch (error) {
            console.error(error);
            showDangerToast(error.message);
        } finally {
            dispatch(updateLoading(false));
        }
    };

    // Generate random string
    const generateRandomString = (length) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
    };

    // Fetch country code list
    const getCountryCodeList = async () => {
        try {
            dispatch(updateLoading(true));
            const path = urls.countryCodeList;
            const res = await ApiCaller.get({}, path, userData?.access_token);
            const response = await res.response.json();
            if (response.status === 200 || response.status === '200') {
                setCountryCodeList(response?.data);
            } else {
                showDangerToast(response.message);
            }
        } catch (error) {
            console.error(error);
            showDangerToast(error.message);
        } finally {
            dispatch(updateLoading(false));
        }
    };

    const getFormattedDate = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const yyyy = today.getFullYear();

        return `${dd}-${mm}-${yyyy}`;
    }

    // Confirm and generate bot accounts
    const confirmAndGenerateData = () => {
        dispatch(updateLoading(true));
        const tempUsers = fileData.map(data => ({
            profilePicture: data?.profile || defaultImage,
            fullName: data?.fullName,
            userName: data?.userName,
            email: data?.email,
            mobile: generateRandomString(10),
            bio: data?.bio,
            gender: data?.gender,
            extNumber: selectedCountry?.code,
            dateOfBirth: getFormattedDate(),
            imageError: false
        }));
        setUsers(tempUsers);
        setShowGenAiModal(false);
        dispatch(updateLoading(false));
    };

    // Confirm bot account creation
    const confirmBotAccount = async () => {
        try {
            dispatch(updateLoading(true));
            const path = urls.createBotAccount;
            const postJson = {
                countryId: countryDropdownText?.id,
                categoryIds: selectedCategoryValues,
                botAccounts: users
            };
            const res = await ApiCaller.post(postJson, path, userData?.access_token);
            const response = await res.response.json();
            console.log("Response from bot account creation:", response);
            if ((response.status === 200 || response.status === '200') && (!response.data || response.data.length === 0)) {
                showToast(response.message);
                navigate('/bot-manager');
            } else if (
                response.message &&
                response.message.includes('Some bot accounts failed to generate. Please check the logs for details.') &&
                Array.isArray(response.data) &&
                response.data.length > 0
            ) {
                showDangerToast(response.message);
                setUsers(response.data.map(bot => ({
                    ...bot,
                    imageError: false
                })));
                setFailedBots(response.data.map(bot => ({
                    userName: bot.userName,
                    error: bot.failureMessage || bot.error || bot.message || 'Unknown error'
                })));
            } else if (response.status === 101 && response.message) {
                // Handle single error (e.g. mobile already registered)
                showDangerToast(response.message);
                setFailedBots(users.map(u => ({ userName: u.userName, error: response.message })));
            } else {
                showDangerToast(response.message);
            }
        } catch (error) {
            console.error(error);
            showDangerToast(error.message);
        } finally {
            dispatch(updateLoading(false));
        }
    };

    useEffect(() => {
        getCountryCodeList();
        getCategoryFilterData();
    }, []);

    return (
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                <div className='container-fluid mt--7'>
                    <div className='row'>
                        <div className='col-12 mb-3 text-left'>
                            <a
                                onClick={() => router("/bot-manager")}
                                className='btn btn-sm btn-primary text-white'
                                style={{ display: 'inline-flex', alignItems: 'center' }}
                            >
                                <ReplyIcon style={{ marginRight: 4 }} />
                                Back
                            </a>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col text-left'>
                            <div className='card shadow'>
                                <div className='card-header border-0'>
                                    <div className='row align-items-center text-left'>
                                        <div className='col'>
                                            <h3 className='mb-0'>Generate Bot Account</h3>
                                        </div>
                                        <div className='col text-right'>

                                            <Button
                                                className='btn btn-sm btn-primary text-white'
                                                onClick={confirmBotAccount}
                                                aria-label="Confirm Bot Account Creation"
                                            >
                                                <CheckIcon />
                                                Confirm
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div className='table-responsive'>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="profile table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Profile Picture</TableCell>
                                                    <TableCell>Full Name</TableCell>
                                                    <TableCell>Username</TableCell>
                                                    <TableCell>Email</TableCell>
                                                    <TableCell>Mobile</TableCell>
                                                    <TableCell>Bio</TableCell>
                                                    <TableCell>Gender</TableCell>
                                                    <TableCell>Ext Number</TableCell>
                                                    <TableCell>Date of Birth</TableCell>
                                                    {failedBots.length > 0 && <TableCell style={{ color: 'red' }}>Error</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {users.map((user, index) => {
                                                    // Find error for this user if any
                                                    let errorMsg = '';
                                                    if (failedBots.length > 0) {
                                                        const failed = failedBots.find(f => f.userName === user.userName);
                                                        if (failed && failed.error) errorMsg = failed.error;
                                                    }
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                <Avatar
                                                                    alt={user.fullName}
                                                                    src={user?.imageError ? defaultImage : user.profilePicture}
                                                                    onError={() => {
                                                                        setUsers(prevUsers => {
                                                                            const newUsers = [...prevUsers];
                                                                            newUsers[index].imageError = true;
                                                                            newUsers[index].profilePicture = defaultImage;
                                                                            return newUsers;
                                                                        });
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    value={user.fullName}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].fullName = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    value={user.userName}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].userName = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    value={user.email}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].email = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    value={user.mobile}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].mobile = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    value={user.bio}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].bio = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <Select
                                                                    value={user.gender}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].gender = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                >
                                                                    <MenuItem value="MALE">Male</MenuItem>
                                                                    <MenuItem value="FEMALE">Female</MenuItem>
                                                                    <MenuItem value="OTHERS">Other</MenuItem>
                                                                </Select>
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    value={user.extNumber || ''}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].extNumber = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    value={user.dateOfBirth || ''}
                                                                    onChange={(e) => {
                                                                        const updatedUsers = [...users];
                                                                        updatedUsers[index].dateOfBirth = e.target.value;
                                                                        setUsers(updatedUsers);
                                                                    }}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            </TableCell>
                                                            {failedBots.length > 0 && <TableCell style={{ color: 'red', maxWidth: 200, whiteSpace: 'pre-line' }}>{user.failureMessage || errorMsg}</TableCell>}
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                show={showGenAiModal}
                onHide={() => setShowGenAiModal(!showGenAiModal)}
                size='lg'
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Please Select Country and Number of Bots
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Select Country</Form.Label>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant='success'
                                        style={{
                                            backgroundColor: 'white',
                                            color: 'black',
                                            border: '1px solid #cad1d7',
                                            boxShadow: 'none'
                                        }}
                                    >
                                        {countryDropdownText?.label}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {countryCodeList.map((item, i) => (
                                            <Dropdown.Item
                                                key={i}
                                                onClick={() => {
                                                    setSelectedCountry(item)
                                                    setCountryDropdownText({ id: item?.id, label: item?.name })
                                                }}
                                            >
                                                {item?.name}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                        </div>
                        <div className='col-md-4'>
                            <Form.Group>
                                <Form.Label>Import Excel</Form.Label>
                                <input type='file' onChange={handleChangeFile} accept='.excel,.csv,.xlsx' />
                            </Form.Group>
                        </div>
                        <div className='col-md-2'>
                            <Form.Group>
                                <Button variant='outlined' onClick={handleDownloadSample}>
                                    {isLoading ? <Spinner animation="border" size="sm" /> : "Download Sample"}
                                </Button>
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group>
                                <Form.Label>Select Category</Form.Label>
                                <Select
                                    multiple
                                    value={selectedCategoryValues}
                                    onChange={(e) => setSelectedCategoryValues(e.target.value)}
                                    renderValue={(selected) => `${selected.length} Selected`}
                                >
                                    {categoryFilterData.map((option) => (
                                        <MenuItem key={option?.value} value={option?.label}>
                                            <Checkbox checked={selectedCategoryValues.indexOf(option?.label) > -1} />
                                            <ListItemText primary={option?.value} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Form.Group>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='outlined' onClick={confirmAndGenerateData}>
                        Generate
                    </Button>
                    <Button variant='outlined' onClick={() => setShowGenAiModal(!showGenAiModal)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};